//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('./BaseMediator')
const ClassFunc = require('../util/ClassFunc')
const Passport = require('../../libs/passport')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_ExecutorInviteMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_ExecutorInviteMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_ExecutorInviteMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    /**
     * @api
     * Handle the creation complete condition triggered by 
     * the scene instance.
     */
    handleCreationComplete: function() {
        console.log('handleCreationComplete')
        const current = this._bridge.getRouteName()
        if (current == 'UserOrgInviteExecutor') {
            this.fetchInvitation(this._bridge.getRouteQuery('ticket'))
        }
        else if (current == 'UserOrgAcceptExecutor') {
            this.target().member = this._bridge.getRouteQuery()
        }
    },
    handleCustomEvent: function(event) {
        console.log('handleCustomEvent', event)
        if (event.type == 'join') {
            this.joinOrganization()
        }
    },
    handleRouteBack: function() {
        console.log('nothing')
    },
    joinOrganization: function() {
        const self = this
        // validate the passport and prepair the one
        Passport.getPassport().then(res => {
            console.log('getPassport', res)
            if (res) {
                self.acceptInvitation(self._bridge.getRouteQuery('ticket'))
            }
        })
    },
    acceptInvitation: function(ticket) {
        console.log('acceptInvitation', ticket)
        const self = this
        self.commitViewObjectData(self.convertor(), {ticket: ticket}, function(e) {
            console.log('commit invitation', e)
            if (e.data.payload) {
                self._bridge.goToScene('UserOrgAcceptExecutor', {}, {
                    roleLabel: self.target().member.roleLabel,
                    organizationName: self.target().member.organizationName
                })
            }
        }, 'accept')
    },
    fetchInvitation: function(ticket) {
        console.log('fetchInvitation', ticket)
        const self = this
        self.loadViewObjectData(self.convertor(), {ticket: ticket}, function(data) {
            console.log('load invitation', data)
            self.target().member = data
        }, 'invite')
    }
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_ExecutorInviteMediator, BaseMediator);

module.exports = tbs_controller_ExecutorInviteMediator